import Link from 'next/link'
import client from '@lib/sanity'
import imageUrlBuilder from '@sanity/image-url'
import Image from 'next/image'
import { HiDocumentText } from 'react-icons/hi'

const PageCard = ({ page }) => {
  return (
    <article className="h-full w-full">
      <Link href="/[[...slug]]" as={`/${page.slug.current}`}>
        <a className="block h-full">
          <div className="flex h-full w-full flex-col overflow-hidden rounded border border-primary-500 bg-primary-500 shadow">
            <div className="aspect-video">
              <div className="relative h-full w-full bg-primary-500">
                {page.mainImage && page.mainImage.asset ? (
                  <Image
                    src={imageUrlBuilder(client)
                      .image(page.mainImage)
                      .width(600)
                      .url()}
                    alt={page.title}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                  />
                ) : (
                  <div className="content-stretch flex h-full items-center justify-center text-6xl text-primary-100">
                    <HiDocumentText />
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col justify-between">
              <h3 className="p-2 pb-4 font-medium leading-tight text-white lg:text-xl 2xl:text-xl">
                {page.title}
              </h3>
            </div>
          </div>
        </a>
      </Link>
    </article>
  )
}

export default PageCard
